import { z } from "zod";

/**
 * FuncionarioAssinaturaSchema
 */

export const FuncionarioAssinaturaSchema = z.object({
  ativo: z.coerce.number({ required_error: "Este campo deve ser prenchido!" }),
  idFuncionario: z.coerce.number({ required_error: "Este campo deve ser prenchido!" }),
  nroRegistro: z.string().nullable().default(null),
  file: z.instanceof(File).nullable().default(null),
  limparArquivos: z.coerce.boolean().default(false),
});

/**
 * FuncionarioAssinaturaForm
 */

export type FuncionarioAssinaturaForm = z.infer<typeof FuncionarioAssinaturaSchema>;

/**
 * Default value
 */

export const defaultFuncionarioAssinaturaForm: Partial<FuncionarioAssinaturaForm> = {
  ativo: 1,
}